var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { css, cx } from 'emotion';
import { colors, spacing } from '../../index.react';
import { defaultBoxShadow } from '../../styles/shadows';
import { caption } from '../typography/typographyStyles';
export var createStyle = function createStyle() {
  return cx(css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n    "], ["\n      position: relative;\n    "]))));
};
export var createListStyle = function createListStyle(_a) {
  var hasLabel = _a.hasLabel,
      dropdownOpened = _a.dropdownOpened;
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  top: ", ";\n  background-color: #fff;\n  z-index: 1;\n  margin: 0;\n  padding: ", " 0;\n  border-radius: 2px;\n  box-shadow: ", ";\n  list-style-type: none;\n  ", ";\n"], ["\n  position: absolute;\n  width: 100%;\n  top: ", ";\n  background-color: #fff;\n  z-index: 1;\n  margin: 0;\n  padding: ", " 0;\n  border-radius: 2px;\n  box-shadow: ", ";\n  list-style-type: none;\n  ", ";\n"])), hasLabel ? '74px' : '52px', spacing.xxs, defaultBoxShadow, dropdownOpened ? '' : 'display: none');
};
export var createButtonStyle = function createButtonStyle(_a) {
  var active = _a.active;
  return cx(css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: transparent;\n      border: 0;\n      width: 100%;\n      text-align: left;\n      cursor: pointer;\n      padding: ", " ", ";\n      ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    "], ["\n      background-color: transparent;\n      border: 0;\n      width: 100%;\n      text-align: left;\n      cursor: pointer;\n      padding: ", " ", ";\n      ", ";\n      &:hover {\n        background-color: ", ";\n      }\n    "])), spacing.xxs, spacing.s, caption, colors.grey5), active && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), colors.grey5));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;